import React, { useEffect, useState } from "react";
import MessagesAndInput from "./MessagesAndInput";
import { getTime, truncateText } from "../../utils/utils";
import { PinIcon, SearchIcon, StarIcon } from "../../utils/icons";
import { Avatar } from "antd";
import Female08 from "../../assets/images/Female08.png";
import { useSelector } from "react-redux";
import AttachmentDisplay from "./AttachmentDisplay";
import { getS3Media } from "../../services/awsServices.js";
import { AntDesignOutlined, UserOutlined } from "@ant-design/icons";


const UserMessageListJSX = () => {
  const {
    msgLoading = false,
    selectedUserOrChannel,
    userAttributes,
    messagesObj,
  } = useSelector((state) => state.user);
  const messages = messagesObj[selectedUserOrChannel?.PK];

  return (
    <div className="flex flex-col gap-y-1 flex-grow overflow-y-auto relative mb-20">
      {messages?.length > 0 ? (
        messages?.map((msg, index) => {
          if (msg?.Sender?.includes(userAttributes?.sub)) {
            return (
              <div
                key={index}
                className="self-end bg-gray-500 text-white rounded-t-md rounded-l-md mr-1 px-3 py-1 min-w-[130px] max-w-[80%]"
              >
                {msg?.Attachments?.length > 0 && (
                  <AttachmentDisplay files={msg?.Attachments} />
                )}
                <p
                  className={`text-white max-w-[500px] overflow-scroll noScroll ${
                    msg?.Attachments?.length > 0 ? "mt-2" : ""
                  }`}
                >
                  {msg?.Content}
                </p>
                <p className="text-right text-[10px] text-gray-100">
                  {getTime(msg?.CreatedAt)}
                </p>
              </div>
            );
          }
          return (
            <div
              key={index}
              className="self-start bg-gray-200 text-black rounded-t-md rounded-r-md px-3 py-1 min-w-[130px] max-w-[80%]"
            >
              {msg?.Attachments?.length > 0 && (
                <AttachmentDisplay files={msg?.Attachments} />
              )}
              <p
                className={`text-black ${
                  msg?.Attachments?.length > 0 ? "mt-2" : ""
                }`}
              >
                {msg?.Content}
              </p>
              <p className="text-right text-[10px] text-gray-700">
                {getTime(msg?.CreatedAt)}
              </p>
            </div>
          );
        })
      ) : (
        <div className="flex justify-center items-center w-full h-full">
          <p className="text-gray-500 text-base">No Message</p>
        </div>
      )}
    </div>
  );
  // }
};

// Main
const UserMessagesAndInput = () => {
  const selectedUser =
    useSelector((state) => state.user.selectedUserOrChannel) || {};
  const [dp, setDp] = useState();

  console.log({ selectedUser });
  const msgLoading = useSelector((state) => state.user.msgLoading);

  console.log({ selectedUser });

  async function getImage(url) {
     console.log(url, "urlllllllllll")
    const res = await getS3Media(url);
    console.log(res,"responsesss")
    setDp(res?.data?.url);
  }

  useEffect(() => {
    if(selectedUser?.Documents?.ProfilePicture){
      getImage(selectedUser?.Documents?.ProfilePicture);
    }
  }, [selectedUser]);

  const NameChar = selectedUser?.Name?.charAt(0)

  return (
    // <div className="min-w-[300px] w-full h-full rounded-3xl p-3 shadow-chatBoxShadow border-2 border-red-500">
    <div className="flex flex-col w-full h-full gap-2 relative">
      <div className="flex items-center justify-between bg-[#eae9e9] rounded-full py-2 px-5">
        <div className="flex items-center gap-2">
          <Avatar size={"large"} src={dp} >
          {NameChar}
          </Avatar>
          <h1 className="text-lg">{truncateText(selectedUser?.Name, 10)}</h1>
        </div>
        <div className="bottom-3 flex items-center gap-2 z-50">
          <div className="flex items-center bg-pureWhite p-3 rounded-full">
            <input placeholder="Search" className="outline-none" />
            <SearchIcon />
          </div>
          <PinIcon />
          <StarIcon />
        </div>
      </div>
      {msgLoading ? (
        <div className="flex justify-center items-center w-full h-full">
          <p className="">Loading...</p>
        </div>
      ) : (
        <>
          <UserMessageListJSX />
          <MessagesAndInput />
        </>
      )}
    </div>
  );
};

export default UserMessagesAndInput;
